import { apiGatewayService, ApiType } from "services/api/ApiGatewayService";

export interface PassportReport {
    last_processed?: string;
    device_information?: {
        model?: string;
        imei?: string;
        imei_two?: string;
        serial?: string;
    };
    device_insights?: {
        carrier_name?: string;
        blacklisted?: string;
        graylisted?: string;
        simlock?: string;
        mdm_status?: string;
        lost_stolen_blocked?: string;
    };
    erasure_details?: {
        standard?: string;
        passes?: number;
        state?: string;
        duration?: string;
        performed?: string;
        target?: {
            model?: string;
            type?: string;
            capacity?: string;
        };
    };
    diagnostic_results?: {
        battery_charging?: string;
        oem_parts?: string;
        touch?: string;
        front_camera?: string;
        speaker?: string;
        bluetooth?: string;
        face_id?: string;
        screen?: string;
        rear_camera?: string;
        wifi?: string;
        vibration?: string;
        fingerprint?: string;
        battery_capacity?: number;
        battery_charge_cycles?: number;
    };
}

export interface FetchPassportsResponse {
    reports: PassportReport[];
}

interface FetchPassportsResponseDto {
    reports: PassportReport[];
}

class PassportService {
    public fetchPassports(search: string, abortController?: AbortController): Promise<FetchPassportsResponse> {
        return apiGatewayService
            .invokeApi(`/api/v1/passports?search=${encodeURIComponent(search)}`, "GET", null, {
                abortSignal: abortController?.signal,
                refreshSession: true,
                apiType: ApiType.OLIVER,
            })
            .then((dto: FetchPassportsResponseDto) => ({
                reports: dto.reports,
            }));
    }
}

export const passportService = new PassportService();
